import ColorSchemeService from '@/core/services/colorScheme';
import ConsultantService from '@/core/services/consultant';
import CustomerService from '@/core/services/customer';
import TeamsService from '@/core/services/teams';
import TenantsService from '@/core/services/tenants';
import { Module } from 'vuex';
const tenantsService = new TenantsService();
const customerService = new CustomerService();
const colorSchemeService = new ColorSchemeService();
const teamsService = new TeamsService();
const consultantService = new ConsultantService();

const adminStore: Module<any, any> = {
   state: {},

   getters: {},

   mutations: {},

   actions: {
      async createScheme(context, body) {
         return await colorSchemeService.createScheme(body).then((response) => {
            return response;
         });
      },

      async createTeam(context, body) {
         return await teamsService.createTeam(body).then((response) => {
            return response;
         });
      },

      async createCustomer(context, body) {
         return await customerService.createCustomer(body).then((response) => {
            return response;
         });
      },

      async createConsultant(context, body) {
         return await consultantService.createConsultant(body).then((response) => {
            return response;
         });
      },

      async createTenant(context, body) {
         return await tenantsService.createTenant(body).then((response) => {
            return response;
         });
      },

      async editCustomer(context, { id, body }) {
         return await customerService.editCustomer(id, body).then((response) => {
            return response;
         });
      },

      async editConsultant(context, { id, body }) {
         return await consultantService.editConsultant(id, body).then((response) => {
            return response;
         });
      },

      async patchConsultant(context, { id, body }) {
         const consultant = await consultantService.patchConsultant(id, body);
         return consultant;
      },

      async editTeam(context, { id, body }) {
         return await teamsService.editTeam(id, body).then((response) => {
            return response;
         });
      },

      async editScheme(context, { id, body }) {
         return await colorSchemeService.editScheme(id, body).then((response) => {
            return response;
         });
      },

      async editTenant(context, { id, body }) {
         return await tenantsService.editTenant(id, body).then((response) => {
            return response;
         });
      },

      async deleteCustomer(context, id) {
         return await customerService.deleteCustomer(id).then((response) => {
            return response;
         });
      },

      async deleteConsultant(context, id) {
         return await consultantService.deleteConsultant(id).then((response) => {
            return response;
         });
      },

      async postConsultantJourney(context, { consultantId, journeyId }) {
         return await consultantService.postConsultantJourney(consultantId, journeyId).then((response) => {
            return response;
         });
      },
      async deleteConsultantJourney(context, consultantJourneyId) {
         return await consultantService.deleteConsultantJourney(consultantJourneyId).then((response) => {
            return response;
         });
      },
   },
};

export default adminStore;
